import React from 'react';
import { Container, Label, RadioInput } from './RadioButton.Styled';
import { RadioButtonPropTypes, RadioButtonDefaultProps } from './RadioButton.prop-types';
export const RadioButton = (props) => {
    const { id, value, disabled, label, checked, onClick } = props;
    const onChanged = (val) => {
        onClick && onClick(val);
    };
    return (React.createElement(Container, null,
        React.createElement("div", null,
            React.createElement(RadioInput, { id: id, type: 'radio', defaultValue: value, checked: checked, onChange: e => onChanged(e.target.value), disabled: disabled })),
        React.createElement(Label, null, label)));
};
RadioButton.propTypes = RadioButtonPropTypes;
RadioButton.defaultProps = RadioButtonDefaultProps;
//# sourceMappingURL=RadioButton.js.map